(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cookie-preferences"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-nelly-cookie-settings]');
  if (!button) return;
  const message = button.nextElementSibling;
  message.hidden = true;
  try {
    if (!window.privacyBanner?.showPreferences) throw new Error('Unavailable');
    await window.privacyBanner.showPreferences();
  } catch {
    message.hidden = false;
  }
});
  } catch(e) { console.error(e); }
})();

})();
